<template>
  <div class="container">
    <h3 class="title">Czy istnieją jakieś dodatkowe okoliczności,<br/> o których powinniśmy wiedzieć?</h3>
    <div class="btn-group">
      <button type="button" class="btn gray" :style="{ background: $color }" @click="btnHandler(false)">NIE</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler(true)">TAK</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "StepAdditional",
  methods: {
    ...mapMutations(['setUserData', 'setAssistanceStep']),
    btnHandler (agreed) {
      if (agreed) {
        this.setAssistanceStep('additionalDescription')
      } else {
        this.setAssistanceStep('last')
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepAdditional.vue